import React from "react";
import PropTypes from "prop-types";
import { HelpOutlineOutlined } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Paper, CircularProgress, IconButton } from "@material-ui/core";
import Typography from "../Typography";

const useStyles = makeStyles({
  hint: {
    position: "absolute",
    right: "4px",
    bottom: "4px",
  },
});

const SrCard = ({ title, titleId, value, onIconClick, loading, detail }) => {
  const classes = useStyles();

  return (
    <Paper elevation={0} component="section" aria-labelledby={titleId}>
      <Box
        position="relative"
        display="flex"
        alignItems="center"
        flexDirection="column"
        gridRowGap={20}
        flexGrow={1}
        padding={4}
      >
        <Typography component="h2" variant="h4" id={titleId}>
          {title}
        </Typography>
        {loading ? (
          <CircularProgress />
        ) : (
          <Box display="flex" justifyContent="center">
            <Typography variant="h2" color="primary">
              {value}
            </Typography>
            {detail && (
              <Box position="absolute" marginTop={4}>
                <Typography>{detail}</Typography>
              </Box>
            )}
          </Box>
        )}

        {onIconClick && (
          <IconButton
            onClick={onIconClick}
            size="small"
            className={classes.hint}
          >
            <HelpOutlineOutlined />
          </IconButton>
        )}
      </Box>
    </Paper>
  );
};

SrCard.propTypes = {
  title: PropTypes.element.isRequired,
  titleId: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.element,
  ]).isRequired,
  onIconClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  detail: PropTypes.node,
};

SrCard.defaultProps = {
  onIconClick: false,
  detail: undefined,
};

export default SrCard;
